import { render, staticRenderFns } from "./ListEventPage.vue?vue&type=template&id=453473df&"
import script from "./ListEventPage.vue?vue&type=script&lang=js&"
export * from "./ListEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports